/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { createContext } from 'react';

export const GridContainerContext: import('react').Context<boolean> = createContext(false);
